import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export function setupI18Next(resources: any) {
    return i18next.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
}

export const setupLocales = (en: any, ru: any, kz: any, tr: any) => {
    return setupI18Next({
        en: {
            translation: en,
        },
        ru: {
            translation: ru,
        },
        kz: {
            translation: kz,
        },
        tr: {
            translation: tr,
        },
    });
};
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

export function setupI18Next(resources: any) {
    return i18next.use(initReactI18next).init({
        resources,
        lng: 'en',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });
}

export const setupLocales = (en: any, ru: any, kz: any, tr: any) => {
    return setupI18Next({
        en: {
            translation: en,
        },
        ru: {
            translation: ru,
        },
        kz: {
            translation: kz,
        },
        tr: {
            translation: tr,
        },
    });
};
